import { Users, Lightbulb, Coffee, Calendar, Presentation, UtensilsCrossed } from 'lucide-react';

// Full class strings kept as literals so Tailwind JIT generates them.
export const isBrainGames = (type = '') => (type || '').toLowerCase().includes('brain');
export const isGeekDay = (type = '') => (type || '').toLowerCase().includes('geek');
export const isDinner = (type = '') => (type || '').toLowerCase().includes('dinner');

export const getEventIconComponent = (type = '', icon = '') => {
  if (isBrainGames(type)) return Lightbulb;
  if (isGeekDay(type)) return Presentation;
  if (isDinner(type)) return UtensilsCrossed;
  const map = { handshake: Users, lightbulb: Lightbulb, leaf: Coffee, presentation: Presentation, dinner: UtensilsCrossed };
  return map[icon] || Calendar;
};

export const getEventAccent = (type = '') => {
  if (isBrainGames(type)) {
    return {
      hex: '#64C8FF',
      text: 'text-[#64C8FF]',
      hoverText: 'group-hover:text-[#64C8FF]',
      pill: 'glass-blue text-[#64C8FF]',
    };
  }
  if (isGeekDay(type)) {
    return {
      hex: '#FFB020',
      text: 'text-[#FFB020]',
      hoverText: 'group-hover:text-[#FFB020]',
      pill: 'glass-amber text-[#FFB020]',
    };
  }
  if (isDinner(type)) {
    return {
      hex: '#A855F7',
      text: 'text-[#A855F7]',
      hoverText: 'group-hover:text-[#A855F7]',
      pill: 'glass-purple text-[#A855F7]',
    };
  }
  return {
    hex: '#00FFD1',
    text: 'text-[#00FFD1]',
    hoverText: 'group-hover:text-[#00FFD1]',
    pill: 'glass-teal text-[#00FFD1]',
  };
};
